import React, { useState } from "react";
import UploadPrescription from "../../components/sections/upload-prescription";
import AdditionalDetails from "../../components/sections/additional-details";
import PresSummary from "../../components/sections/pres-summary";
import Steps from "../../components/elements/steps";

const ORDER_STEPS = [
  { title: "Upload" },
  { title: "Details" },
  { title: "Summary" },
];

export default function Ordering() {
  const [tab, setTab] = useState<number>(0);
  const [persist, setPersist] = useState<any>({});

  return (
    <div className="md:p-4 p-2">
      <div className="bg-white rounded-lg w-full min-h-[85vh] py-4">
        <div className="flex justify-center mb-6 px-4">
          <Steps items={ORDER_STEPS} current={tab} />
        </div>
        {tab === 0 && (
          <UploadPrescription
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
        {tab === 1 && (
          <AdditionalDetails
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
        {tab === 2 && (
          <PresSummary
            tab={tab}
            setTab={setTab}
            persist={persist}
            setPersist={setPersist}
          />
        )}
      </div>
    </div>
  );
}
